import { Box } from '@chakra-ui/layout'
import React from 'react'

const Alert = () => {
  return (
    <>
      <Box textAlign="center">There are no todos!</Box>
    </>
  )
}

export default Alert
